/**
 * Client-side utilities for managing notification dismissals in localStorage
 */

const STORAGE_KEY = "inAppNotifications_dismissed"
const PREVIEW_STORAGE_KEY = "inAppNotifications_preview_dismissed"

/**
 * Get all dismissed notification IDs from localStorage
 */
export function getDismissedNotificationIds(): string[] {
	if (typeof window === "undefined") {
		return []
	}

	try {
		const stored = localStorage.getItem(STORAGE_KEY)
		if (!stored) {
			return []
		}
		const parsed = JSON.parse(stored)
		return Array.isArray(parsed) ? parsed : []
	} catch (error) {
		console.error("Error reading dismissed notifications from localStorage:", error)
		return []
	}
}

/**
 * Check if a specific notification ID has been dismissed
 */
export function isNotificationDismissed(notificationId: string, isPreview = false): boolean {
	const storageKey = isPreview ? PREVIEW_STORAGE_KEY : STORAGE_KEY
	if (typeof window === "undefined") {
		return false
	}

	try {
		const stored = localStorage.getItem(storageKey)
		if (!stored) {
			return false
		}
		const parsed = JSON.parse(stored)
		const dismissedIds = Array.isArray(parsed) ? parsed : []
		return dismissedIds.includes(notificationId)
	} catch (error) {
		console.error("Error reading dismissed notifications from localStorage:", error)
		return false
	}
}

/**
 * Add a notification ID to the dismissed list in localStorage
 */
export function dismissNotification(notificationId: string, isPreview = false): void {
	if (typeof window === "undefined") {
		return
	}

	const storageKey = isPreview ? PREVIEW_STORAGE_KEY : STORAGE_KEY

	try {
		const stored = localStorage.getItem(storageKey)
		const dismissedIds = stored ? (JSON.parse(stored) || []) : []
		if (!dismissedIds.includes(notificationId)) {
			const updated = [...dismissedIds, notificationId]
			localStorage.setItem(storageKey, JSON.stringify(updated))
		}
	} catch (error) {
		console.error("Error saving dismissed notification to localStorage", error)
	}
}
